import { makeStyles } from "@material-ui/core";

import { SquareImageChooserProps } from "./SquareImageChooser";

export const useStyles = makeStyles(
  (theme) => ({
    input: {
      display: "none",
    },

    squareWrapper: (props: SquareImageChooserProps) => ({
      display: "block",
      width: "100%",
      height: props.height,
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",

      "& .content": {
        width: "100%",
        height: "100%",

        "& .overlayWrapper": {
          position: "relative",
          width: "100%",
          height: "100%",

          "& .overlay": {
            position: "absolute",
            bottom: 0,
            right: 0,
            left: 0,

            backgroundColor: theme.palette.secondary.main,
            opacity: 0.4,
            height: props.height,
          },

          "& .removeAction": {
            display: "inline-block",
            position: "absolute",
            backgroundColor: theme.palette.common.black,
            opacity: 0.6,
            color: theme.palette.common.white,

            bottom: 12,
            right: 12,
            borderRadius: "100%",
            width: 26,
            height: 26,
            cursor: "pointer",
            textAlign: "center",
          },
        },

        "& .progressWrapper": {
          position: "relative",
          width: "100%",
          display: "block",
          height: props.height,
          border: `1px dashed ${theme.palette.common.black}`,
          cursor: "default",
          padding: "0 20px",

          "& .loader": {
            display: "inline-block",
            position: "absolute",

            bottom: 12,
            right: 14,
            width: 26,
            height: 26,
            cursor: "default",
          },
        },

        "& label": {
          width: "100%",
          display: "block",

          "& .actionWrapper": {
            height: props.height,
            border: `1px dashed ${theme.palette.common.black}`,
            cursor: "pointer",
            padding: "0 20px",

            "& span": {
              textAlign: "center",
            },

            "&:hover": {
              backgroundColor: "#FCFCFC",
            },
          },
        },
      },
    }),
  }),
  { name: "square-image-chooser-style", flip: null }
);
